import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../components/ui/Button'
import { LeftArrowWhite } from '../../assets/images/svg/LeftArrow'
import PhoneNumberInput from '../../components/ui/PhoneNumberInput'
import { sendSms } from 'src/services/functionServices'
import { observer } from 'mobx-react'
import { applicationStore } from 'src/store/ApplicationStore'
import { toast } from 'react-toastify'
import Preloader from 'src/components/ui/Preloader'
import { useTranslation } from 'react-i18next'

const ContinueOnAnotherDeviceSms = observer(() => {
    const navigate = useNavigate();
    const [isActive, setIsActive] = useState(false);
    const [phoneValue, setPhoneValue] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const { t } = useTranslation();

    const handleSendSms = async () => {
        try {
            setSubmitting(true);
            await sendSms(phoneValue, applicationStore.access_token);
            toast.success(t('checkYourDevice.smsSent'));
            applicationStore.setContinueOnAnotherDeviceSmsOrEmail("/continue-on-another-device-sms");
            navigate("/check-your-device", { replace: true, state: { phoneValue } });
        } catch (error) {
            toast.error(t('checkYourDevice.smsNotSent'));
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <div className="custom-container">
            <div className="flex justify-between flex-col items-center h-full">
                <div>
                    <div className='text-left'>
                        <Button className="" variant="primaryBack" onClick={() => { navigate("/continue-on-another-device", { replace: true }) }}><LeftArrowWhite /></Button>
                    </div>
                    <div className='grid gap-[16px] mt-10'>
                        <div className="text-h5 font-bold text-flow-heading">{t('continueAnother.title')}</div>
                        <div className="text-body text-Gray900">{t('continueAnother.description.sms')}</div>
                    </div>
                    <div className='mt-10'>
                        <div className='text-left mb-1'>
                            <span className='text-xs text-Gray900'>{t('continueAnother.phoneLabel')}</span>
                        </div>
                        <PhoneNumberInput setIsActive={setIsActive} setPhoneValue={setPhoneValue} />
                    </div>
                    <div className='mt-6'>
                        <Button className="mt-4" variant="primaryWithoutIcon" disabled={!isActive || submitting} onClick={handleSendSms}>
                            <span className="me-1">{t('continueAnother.sendSecureLink')}</span>{submitting && <Preloader variant='white' />}
                        </Button>
                    </div>
                </div>
                <div className="">
                </div>
            </div>
        </div>
    )
})

export default ContinueOnAnotherDeviceSms
